<template>
  <div id="update-data-page">
    <h2 class="intro-y text-lg font-medium mt-10">
      {{ isCopy ? '複製' : '更改'}}東華三院電郵系統帳戶設定申請表
    </h2>

    <email-workflow-form v-if="checkPermission(permissions, 'system.workflow.email-workflow')" :data="data" :all-sites="allSites" :site="currentSite" @isCopy="checkIsCopy"></email-workflow-form>
    <div v-else-if="mounted">
      <div class="alert alert-danger show mt-2" role="alert">沒有權限查看</div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['auth', 'allSites', 'currentSite', 'permissions'],
  data() {
    return {
      mounted: false,
      data: null,
      isCopy: false
    }
  },
  watch: {
    auth(val) {
      if (val) {
        this.init()
      }
    },
    currentSite() {
      this.init()
    }
  },
  async mounted() {
    if (!this.auth) {
      return
    }

    await this.init()
  },
  methods: {
    async init() {
      if (this.currentSite) {
        await this.loadData()
        this.mounted = true
      }
    },
    async loadData() {
      this.data = await this.getWorkflow('email', this.$route.params.applicationId)
    },
    checkIsCopy(val) {
      this.isCopy = val
    }
  }
}
</script>

<style lang="scss" scoped></style>
